import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useState } from "react";
import Button from "@overrides_venia/venia-ui/components/Button";
import Modal from "@Components/Modal";
import { useIntl } from "react-intl";
import { useHistory } from "@Src_main/drivers";
import { Form } from "informed";

// Assets
import bg_modal_d from "../../assets/images/profile-step/modal-bg/modal-bg-d.png";
import bg_modal_m from "../../assets/images/profile-step/modal-bg/modal-bg-m.png";
import bg1M from "../../assets/images/profile-step/background/profile-1-m.png";
import bg1D from "../../assets/images/profile-step/background/profile-1-d.png";
import bg2M from "../../assets/images/profile-step/background/profile-2-m.png";
import bg2D from "../../assets/images/profile-step/background/profile-2-d.png";
import bg3M from "../../assets/images/profile-step/background/profile-3-m.png";
import bg3D from "../../assets/images/profile-step/background/profile-3-d.png";
import bg4M from "../../assets/images/profile-step/background/profile-4-m.png";
import bg4D from "../../assets/images/profile-step/background/profile-4-d.png";

// Styles
import defaultClasses from "@Src_main/components/UpdateCustomerPage/updateCustomerPage.module.scss";
import stepsClasses from "@Src_main/components/UpdateCustomerPage/profileSteps.module.scss";
import { mergeClasses } from "@magento/venia-ui/lib/classify";
import { useMutation } from "@apollo/client";
import { useWindowSize } from "@overrides_venia/peregrine/hooks/useWindowSize";
import { useUserContext } from "@overrides_venia/peregrine/context/user";

// Components
import DobField from "@Components/FormFields/DobField";
import { SimpleField } from "@Components/FormFields/SimpleField";
import StoreBookFormField from "@Components/FormFields/storeBookFormField";
import { GenderField } from "@Components/FormFields/GenderField";
import useStores from "@Src_main/utils/useStores";

// GraphQL
import { UPDATECUSTOMERV2 } from "@Src_main/pages/MyAccountData/customerInfo.js";
import { CREATE_CUSTOMER_ADDRESS_MUTATION } from "@Src_main/pages/MyAccountData/customerInfo.js";
import { UPDATE_CUSTOMER_ATTRIBUTES } from "@Components/MyAccount/Data/Info/updateCustomerAttributes.gql.js";
export var ModalCompleteCustomerData = _ref => {
  var {
    isOpen,
    setIsOpen
  } = _ref;
  var {
    formatMessage
  } = useIntl();
  var {
    isMobile
  } = useWindowSize();
  var activeStep = 3;
  var [handleUpdateCustomer] = useMutation(UPDATECUSTOMERV2);
  var [handleCreateAddress] = useMutation(CREATE_CUSTOMER_ADDRESS_MUTATION);
  var [handleUpdateCustomerAttributes] = useMutation(UPDATE_CUSTOMER_ATTRIBUTES);
  var [{
    isUserComplete,
    hasUserMandatoryFields,
    currentUser
  }] = useUserContext();
  var [dobValue, setDobValue] = useState(currentUser === null || currentUser === void 0 ? void 0 : currentUser.date_of_birth);
  var [selectedStore, setSelectedStore] = useState(null);
  var [hasAttemptedSubmit, setHasAttemptedSubmit] = useState(false);
  var [showOptionalData, setShowOptionalData] = useState(false);
  var [loading, setLoading] = useState(false);
  var {
    stores
  } = useStores();
  var [isModalSelectionOpen, setIsModalSelectionOpen] = useState(false);
  var classes = mergeClasses(defaultClasses, stepsClasses);
  var updateCustomerIfNecessary = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(function* (variables) {
      setLoading(true);
      try {
        yield handleUpdateCustomer({
          variables
        });
      } finally {
        setLoading(false);
        UIkit.slider("#optionalDataSlider").show(1);
      }
    });
    return function updateCustomerIfNecessary(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var updateDobIfNecessary = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(function* (variables) {
      setLoading(true);
      try {
        yield handleUpdateCustomer({
          variables
        });
      } finally {
        setLoading(false);
        UIkit.slider("#optionalDataSlider").show(2);
      }
    });
    return function updateDobIfNecessary(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();
  var updateAddressIfNecessary = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(function* (variables) {
      setLoading(true);
      try {
        yield handleCreateAddress({
          variables
        });
      } finally {
        setLoading(false);
      }
    });
    return function updateAddressIfNecessary(_x3) {
      return _ref4.apply(this, arguments);
    };
  }();
  var updateAttributesIfNecessary = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(function* () {
      setLoading(true);
      try {
        yield handleUpdateCustomerAttributes({
          variables: {
            attributes: [{
              attribute_code: "FAV_STORE",
              attribute_value: selectedStore ? selectedStore.ls_store_id : null
            }]
          }
        });
      } finally {
        setLoading(false);
        setIsOpen(false);
      }
    });
    return function updateAttributesIfNecessary() {
      return _ref5.apply(this, arguments);
    };
  }();
  var onClickFunction = (values, step) => {
    if (step === 1) {
      updateDobIfNecessary(_objectSpread(_objectSpread({}, values), {}, {
        dob: dobValue
      }));
    } else if (step === 3) {
      updateAddressIfNecessary(_objectSpread(_objectSpread({}, values), {}, {
        firstname: currentUser.firstname || 'anon',
        lastname: currentUser.lastname || 'anon'
      }));
    } else if (step === 4) {
      updateAttributesIfNecessary();
    } else {
      updateCustomerIfNecessary(values);
    }
  };
  var notNowFunction = () => setIsOpen(false);
  var showOptionalDataFunction = () => setShowOptionalData(true);
  var getBgBasedOnStep = (step, isMobile, backgroundPosition, backgroundSize) => {
    var bgImages = {
      1: isMobile ? bg1M : bg1D,
      2: isMobile ? bg2M : bg2D,
      3: isMobile ? bg3M : bg3D,
      4: isMobile ? bg4M : bg4D
    };
    return {
      backgroundImage: "url('".concat(bgImages[step] || bg_modal_m, "')"),
      backgroundRepeat: "no-repeat",
      backgroundPosition: backgroundPosition || "right bottom",
      backgroundSize: backgroundSize || "cover",
      minHeight: "80dvh",
      maxHeight: "80dvh",
      width: isMobile || step > 0 ? "100%" : "50dvw"
    };
  };
  var renderStepSlider = (step, order, titleId, subtitleId, fields, initialValues, backgroundPosition, backgroundSize) => /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes['profile-step-bgimages'], " uk-width-1-1"),
    style: getBgBasedOnStep(step, isMobile, backgroundPosition, backgroundSize)
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes['container-standard'], " uk-container")
  }, /*#__PURE__*/React.createElement(Form, {
    className: "".concat(classes['form-container'], " uk-flex uk-flex-column uk-text-creamer"),
    onSubmit: values => onClickFunction(values, step),
    initialValues: initialValues
  }, /*#__PURE__*/React.createElement("div", {
    className: "uk-padding ".concat(classes['profile-'])
  }, /*#__PURE__*/React.createElement("div", {
    className: "uk-text-uppercase ".concat(classes['form-input'])
  }, /*#__PURE__*/React.createElement("div", {
    className: "uk-flex ".concat(classes['steps-container'])
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes['step'])
  }, /*#__PURE__*/React.createElement("span", {
    className: "".concat(classes['number'])
  }, order), /*#__PURE__*/React.createElement("span", {
    className: "".concat(classes['number'])
  }, activeStep))), /*#__PURE__*/React.createElement("div", {
    className: "uk-light uk-text-center uk-margin-large-bottom"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "".concat(classes['title'], " uk-light uk-text-uppercase")
  }, formatMessage({
    id: titleId
  })), /*#__PURE__*/React.createElement("div", null, formatMessage({
    id: subtitleId
  }))), fields), /*#__PURE__*/React.createElement("div", {
    className: "uk-position-bottom uk-position-small uk-text-center"
  }, /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    color: "primary"
  }, loading ? /*#__PURE__*/React.createElement("div", {
    "uk-spinner": "ratio: 2"
  }) : /*#__PURE__*/React.createElement("span", null, formatMessage({
    id: "button.confirm"
  }))))))));
  var askForBirthdate_slider = renderStepSlider(1, 2, "registration.profile.step1.title", "registration.profile.step1.subtitle", /*#__PURE__*/React.createElement(DobField, {
    borderClass: "uk-border-creamer",
    backgroundClass: "uk-background-transparent",
    value: dobValue,
    setValue: setDobValue,
    required: false,
    showInvalid: hasAttemptedSubmit
  }), {
    dob: dobValue
  });
  var askNameandGender_slider = renderStepSlider(2, 1, "registration.profile.step2.title", "registration.profile.step2.subtitle", /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SimpleField, {
    borderClass: "uk-border-creamer",
    backgroundClass: "uk-background-transparent",
    label: "name",
    name: "firstname",
    required: true,
    showInvalid: hasAttemptedSubmit
  }), /*#__PURE__*/React.createElement(SimpleField, {
    borderClass: "uk-border-creamer",
    backgroundClass: "uk-background-transparent",
    label: "surname",
    name: "lastname",
    required: false
  }), /*#__PURE__*/React.createElement(GenderField, {
    backgroundClass: "uk-background-transparent",
    required: false,
    showInvalid: hasAttemptedSubmit,
    showLabel: true
  })), {
    firstname: currentUser === null || currentUser === void 0 ? void 0 : currentUser.firstname,
    lastname: currentUser === null || currentUser === void 0 ? void 0 : currentUser.lastname,
    gender: currentUser === null || currentUser === void 0 ? void 0 : currentUser.gender
  }, "top right");
  var askStoreAndPhone_slider = renderStepSlider(4, 3, "registration.profile.step4.title", "registration.profile.step4.subtitle", /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StoreBookFormField, {
    selectedStore: selectedStore,
    setSelectedStore: setSelectedStore,
    allStores: stores,
    isModalSelectionOpen: isModalSelectionOpen,
    setIsModalSelectionOpen: setIsModalSelectionOpen,
    showStoreHours: false,
    disabled: false,
    hidden: false,
    applySelectedClasses: true,
    fieldTextWhenEmpty: "fav.store"
  })));
  var askAddress_slider = renderStepSlider(3, 4, "registration.profile.step3.title", "registration.profile.step3.subtitle", /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SimpleField, {
    borderClass: "uk-border-creamer",
    backgroundClass: "uk-background-transparent",
    label: "address",
    name: "addressComplete",
    required: false
  }), /*#__PURE__*/React.createElement(SimpleField, {
    borderClass: "uk-border-creamer",
    backgroundClass: "uk-background-transparent",
    label: "cap",
    name: "postcode",
    required: false
  }), /*#__PURE__*/React.createElement(SimpleField, {
    borderClass: "uk-border-creamer",
    backgroundClass: "uk-background-transparent",
    label: "city",
    name: "city",
    required: false
  }), /*#__PURE__*/React.createElement(SimpleField, {
    label: "phone.number",
    name: "telephone",
    borderClass: "uk-border-creamer",
    backgroundClass: "uk-background-transparent",
    type: "tel",
    required: false,
    showInvalid: hasAttemptedSubmit
  })));
  var askForOptionalData_slider = /*#__PURE__*/React.createElement("div", {
    "data-uk-slider": true,
    id: "optionalDataSlider",
    className: "uk-border-rounded uk-overflow-hidden ".concat(classes['profile-steps'])
  }, /*#__PURE__*/React.createElement("div", {
    className: "uk-slider-items ".concat(classes['bg-container'], " ").concat(classes['bg-container_step2'], " ").concat(classes['profile-step-page'])
  }, askNameandGender_slider, askForBirthdate_slider, askStoreAndPhone_slider));
  var askForCompletion = /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement("div", {
    className: "uk-position-relative uk-flex uk-flex-column ".concat(classes.fullfeedback_container),
    style: getBgBasedOnStep(0, isMobile, isMobile ? "center bottom" : "right", "cover")
  }, /*#__PURE__*/React.createElement("div", {
    className: "uk-text-center uk-flex uk-flex-middle"
  }, /*#__PURE__*/React.createElement("div", {
    className: "uk-text-center uk-light uk-margin-medium-bottom uk-margin-medium-top ".concat(classes.info_text)
  }, /*#__PURE__*/React.createElement("span", {
    className: "uk-text-uppercase ".concat(classes.status)
  }, formatMessage({
    id: "feedback.registration.profilo.capiton"
  })), /*#__PURE__*/React.createElement("h1", {
    className: "uk-text-uppercase ".concat(classes.title)
  }, formatMessage({
    id: "feedback.registration.profilo.title"
  })), /*#__PURE__*/React.createElement("div", {
    className: "uk-margin-bottom"
  }, formatMessage({
    id: "feedback.registration.profilo.subtitle"
  })), /*#__PURE__*/React.createElement("div", {
    onClick: notNowFunction,
    className: "uk-text-uppercase ".concat(classes.next_time)
  }, formatMessage({
    id: "feedback.registration.profilo.link"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "uk-position-bottom uk-position-small"
  }, /*#__PURE__*/React.createElement(Button, {
    id: "completeProfile",
    onClick: showOptionalDataFunction,
    color: "miscusi_red",
    type: "button",
    height: "small",
    fullScreen: true,
    extraClass: "uk-align-center"
  }, formatMessage({
    id: "feedback.registration.profilo.button"
  })))));
  return /*#__PURE__*/React.createElement(Modal, {
    id: "modal-complete-data-selection",
    modalCloseOutside: true,
    modalDialogClass: isMobile ? "uk-border-rounded uk-position-bottom uk-padding-remove" : "uk-position-center uk-width-auto uk-border-rounded",
    animation: isMobile ? 'uk-animation-slide-bottom' : "uk-animation-scale-up",
    isOpen: isOpen,
    onClose: () => setIsOpen(false),
    canBeClosed: true
  }, showOptionalData ? askForOptionalData_slider : askForCompletion);
};